import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Admission</h1>
                <p>Home &gt; Admission</p>
            </div>
        </div>
    )
}

export default Hero;